export function RequiredAsterisk() {
  return (
    <span className="text-red-500" aria-hidden="true">
      *
    </span>
  );
}
